(function(){
     'use strict';

     angular
        .module('app')
        .factory('ReportDefaultService', ReportDefaultService);

    ReportDefaultService.$inject = ['$http'];
 
    function ReportDefaultService($http){

        var service= {
        	getReport:getReport
        };

        return service;


        function getReport(url,report_id)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                    'Cache-Control' : 'no-cache'
                }
            };
            
            return $http.get(url,{ params : {report_id:report_id }  })
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                return data.data;
            }
            function getContentFailed(data){
                
                return data.data;
            }
        }

       

    }
})();